/* src/app/main/pages/home-page/component/our-services/our-services.component.css */
.our-services-row .card {
  margin-bottom: 50px;
  border: none;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}
.our-services-row .card-body {
  display: flex;
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 0;
  height: 270px;
}
.our-services-row .card-body:after {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  border-top: 25px solid #213654;
  border-right: 20px solid #213654;
  border-bottom: 24px solid transparent;
  border-left: 20px solid transparent;
}
.our-services-row .img-before {
  position: absolute;
  right: 18px;
  top: 0;
  bottom: 0;
  width: 63%;
  height: 100%;
}
.our-services-row .img-after {
  position: absolute;
  right: 0;
  height: 100%;
}
.our-services-row .left-col {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 10px;
  z-index: 1;
}
.our-services-row .left-col ul {
  height: 150px;
  list-style: none;
  padding-left: 0px !important;
}
.our-services-row .left-col ul.large-text {
  height: 122px;
}
.our-services-row .left-col li {
  padding-bottom: 6px;
}
.our-services-row .left-col li a {
  color: #191919;
  font-size: 15px;
}
.our-services-row .left-col li .list-number {
  color: #E8882D;
  padding-right: 5px;
  font-weight: 600;
}
.our-services-row .left-col .more-link {
  padding-left: 25px;
}
@media (min-width: 1600px) {
  .our-services-row .left-col .card-title {
    margin-bottom: 20px;
    font-size: 30px;
  }
}
@media (min-device-width: 1600px) {
  .our-services-row .card-body {
    height: 350px;
  }
  .our-services-row .left-col ul {
    height: 180px;
  }
  .our-services-row .left-col li {
    font-size: 20px;
  }
}
@media (min-device-width: 1440px) and (max-device-width: 1599px) {
  .our-services-row .left-col li {
    font-size: 17px;
  }
}
@media (max-width: 768px) {
  .our-services-row .img-before {
    left: -2px;
    width: 100%;
  }
  .our-services-row .card {
    margin-bottom: 30px !important;
  }
}
@media (max-width: 767px) {
  .mobile-card .card-body {
    display: block;
    height: auto;
    padding: 0;
  }
  .mobile-card .card-body::after {
    content: none;
  }
  .our-services-row .left-col {
    position: relative;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    height: 256px;
  }
  .mobile-card .mobile-card-bg {
    position: absolute;
    z-index: 99;
    top: 0;
    right: 0;
    width: 47%;
  }
  .our-services-row .mobile-card .left-col ul {
    height: 135px;
  }
  .our-services-row .mobile-card .left-col li {
    font-size: 16px;
    padding-top: 15px;
  }
  .our-services-row .left-col .more-link {
    padding-left: 0;
    font-size: 17px;
  }
}
@media (min-device-width: 411px) and (max-device-width: 414px) {
  .mobile-card .mobile-card-bg {
    width: 41%;
  }
}
@media (device-width: 375px) {
  .mobile-card .mobile-card-bg {
    width: 45%;
  }
}
@media (max-width: 350px) {
  .mobile-card .mobile-card-bg {
    width: 54%;
  }
  .our-services-row .mobile-card .left-col li {
    font-size: 13px;
  }
  .our-services-row .mobile-card .card-title {
    font-size: 20px;
  }
}
/*# sourceMappingURL=our-services.component.css.map */
